module.exports = __webpack_public_path__ + "img/smart0-xiaochengxucode.b1995bb8.png";